/** @deprecated */
export const defaultPrimaryColor = "#12393F"

//portfolio tree starts index at 0, so this is really max depth of 5
export const WorkspaceTreeMaxDepth = 4

export const animationClass = "duration-150 ease-in-out"

export const defaultFolderName = "New Folder"
export const defaultProjectName = "Untitled"

export const maxBreadcrumbFolderLength = 25
